import React from 'react'
import './About.css'
function About() {
  return (
    <div className='about'>
        <h1>ABOUT</h1>
        <h1>EVANGADI NETWORKS</h1>
        <p>No matter what stage of life you are in, whether you are just starting elementary school or being promoted to CEO of a Fortune 500 company, you have much to offer to those who are trying to follow in your footsteps.</p>
        
        <p>Wheather you are willing to share your knowledge or you are just looking to meet mentors of your own, please start by joining the network here.</p>
        <button>How it works</button>

    </div>
  )
}

export default About